// ImageSlider.jsx
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import styles from "./index.module.css";
// Only presentation rendering needs this URL handling. Keep other documents unchanged.
const ASI_BASE = "https://api.asicentral.com/v1/";
const resolvePresentationImageUrl = (value, size = "large") => {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) return "";
  const asiPath = raw.replace(/^\/+/, "").replace(/^v1\//i, "");
  if (/^(?:media\/\d+)(?:[?#]|$)/i.test(asiPath) || /^\d+$/.test(raw)) {
    const path = /^\d+$/.test(raw) ? `media/${raw}` : asiPath;
    const url = new URL(path, ASI_BASE);
    url.searchParams.set("size", size);
    return url.toString();
  }
  if (/^https?:\/\/api\.asicentral\.com\/v1\/media\/\d+/i.test(raw)) {
    const url = new URL(raw);
    url.searchParams.set("size", size);
    return url.toString();
  }
  // Keep customer-upload URLs, data/blob URLs, and local assets as stored.
  return raw;
};

const ImageSlider = ({ productImages = [], productImage, mainImage }) => {
  const gallery = Array.isArray(productImages) && productImages.length ? productImages : (Array.isArray(productImage) ? productImage : []);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
     setCurrent(mainImage || gallery[0] || null);
  }, [mainImage, productImages, productImage]);

  const showArrows = gallery.length > 1;
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:gallery.length >= 3 ? 3 : gallery.length,
    slidesToScroll: 1,
    arrows: showArrows,
    prevArrow: <div className={`${styles["slick-prev"]} ${styles.arrowLeft}`} />,
    nextArrow: <div className={`${styles["slick-next"]} ${styles.arrowRight}`} />,
  };
  return (
    <Box className={styles.sliderRoot}>
      <Box className={styles.primaryImageContainer}>
        {current && (
          <img
            src={resolvePresentationImageUrl(current, "large")}
            alt="product_view"
            className={styles.primaryImage}
          />
        )}
      </Box>

      {showArrows && (
        <Box className={styles.secondaryCarousel}>
          <Slider {...settings}>
            {gallery.map((imgPath, idx) => (
              <Box key={idx} className={styles.secondaryImageCarousel}>
                <img
                  src={resolvePresentationImageUrl(imgPath, "normal")}
                  alt={`Thumbnail ${idx + 1}`}
                  className={styles.secondaryImageSlide}
                  onClick={() => setCurrent(imgPath)}
                />
              </Box>
            ))}
          </Slider>
        </Box>
      )}
    </Box>
  );
};

export default ImageSlider;
